import { render, staticRenderFns } from "./set_up_my_checklists.vue?vue&type=template&id=8568109a&scoped=true"
import script from "./set_up_my_checklists.vue?vue&type=script&lang=js"
export * from "./set_up_my_checklists.vue?vue&type=script&lang=js"
import style0 from "./set_up_my_checklists.vue?vue&type=style&index=0&id=8568109a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8568109a",
  null
  
)

export default component.exports